<template>
  <div class="mx-auto w-full max-w-5xl">
    <div class="bg-white shadow">
      <div class="px-4 py-6 border-b border-gray-200 sm:px-6">
        <h3 class="text-xl leading-6">
          {{ $t(`mygwf.components.Card.profile`) }}
        </h3>
        <p class="mt-1 max-w-2xl leading-5 text-secondary-dark">
          {{ $t(`mygwf.components.Card.profile.subtitle`) }}
        </p>
      </div>
      <div>
        <dl>
          <div class="bg-white px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 items-center">
            <dt class="leading-5 font-medium text-secondary-dark">
              {{ $t(`mygwf.components.Form.name`) }}
            </dt>
            <dd
              class="mt-1 leading-5 sm:mt-0 sm:col-span-2 space-x-4 flex items-center justify-between"
            >
              <base-input v-model="name" class="w-full pb-0" />
              <base-button
                @click="update"
                :loading="loading"
                action="update"
                class="mb-2 lg:mb-3"
              />
            </dd>
          </div>
          <div class="bg-white px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 items-center">
            <dt class="leading-5 font-medium text-secondary-dark">
              {{ $t(`mygwf.components.Form.email`) }}
            </dt>
            <dd class="mt-1 leading-5 sm:mt-0 sm:col-span-2">
              {{ currentUser.email }}
            </dd>
          </div>
          <!-- <div class="bg-white px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 items-center">
            <dt class="leading-5 font-medium text-secondary-dark">
              {{ $t(`mygwf.components.Form.language`) }}
            </dt>
            <dd class="mt-1 leading-5 sm:mt-0 sm:col-span-2">
              <SelectLocale />
            </dd>
          </div> -->
          <div class="bg-white px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 items-center">
            <dt class="leading-5 font-medium text-secondary-dark">
              {{ $t(`mygwf.components.Form.password`) }}
            </dt>
            <dd class="mt-1 leading-5 sm:mt-0 sm:col-span-2">
              <base-button @click="showModal = true" action="change_password" />
            </dd>
          </div>
        </dl>
      </div>
    </div>
    <base-modal v-if="showModal" @close="showModal = false" head="change_password">
      <change-password-form @close="showModal = false" @changed="showModal = false" />
    </base-modal>
  </div>
</template>

<script>
import {BaseInput, BaseModal, BaseButton} from '@/components/base'
import SelectLocale from '@/components/shared/SelectLocale.vue'
import ChangePasswordForm from './ChangePasswordForm'

export default {
  components: {
    BaseModal,
    BaseInput,
    BaseButton,
    SelectLocale,
    ChangePasswordForm,
  },

  mounted() {
    this.name = this.currentUser.name
  },

  data() {
    return {
      showModal: false,
      loading: false,
      name: '',
      // userProfile: this.$store.getters['auth/activeCompany'],
      pk: this.$store.getters['users/pk'],
    }
  },

  computed: {
    currentUser() {
      return this.$store.getters['auth/currentUser']
    },
  },

  methods: {
    selectProfile(id) {
      this.$store.dispatch('auth/getProfileForUser', id)
    },

    update() {
      this.loading = true
      this.$store
        .dispatch(`profile/update`, {
          id: this.currentUser[this.pk],
          name: this.name,
        })
        .then(data => {
          this.$store.dispatch('app/notification', {type: 'success', group: 'app', text: `updated`})
        })
        .catch(error => {
          this.$store.dispatch('app/notification', {type: 'error', group: 'app', text: `updated`})
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>
